module.exports = __webpack_public_path__ + "static/media/CentraNo2-Book.4ee0f184.woff";